var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9993 3.33301H9.99935C9.11529 3.33301 8.26745 3.6842 7.64233 4.30932C7.0172 4.93444 6.66602 5.78229 6.66602 6.66634V33.333C6.66602 34.2171 7.0172 35.0649 7.64233 35.69C8.26745 36.3152 9.11529 36.6663 9.99935 36.6663H29.9993C30.8834 36.6663 31.7312 36.3152 32.3564 35.69C32.9815 35.0649 33.3327 34.2171 33.3327 33.333V11.6663L24.9993 3.33301Z",
    stroke: "#B64627",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.334 3.33301V9.99967C23.334 10.8837 23.6852 11.7316 24.3103 12.3567C24.9354 12.9818 25.7833 13.333 26.6673 13.333H33.334",
    stroke: "#B64627",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4553_1882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2241 25.6316C13.9484 24.1433 14.213 22.6054 14.9702 21.2948C15.7275 19.9842 16.9277 18.9869 18.3548 18.4824V23.2486L14.2241 25.6316Z",
    stroke: "#B64627",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4725 24.5008V18.1182C21.5859 18.1183 22.6797 18.411 23.6444 18.9669C24.6091 19.5228 25.4108 20.3224 25.9693 21.2856C26.5277 22.2488 26.8233 23.3418 26.8264 24.4552C26.8295 25.5686 26.5401 26.6633 25.987 27.6296C25.434 28.5959 24.6368 29.4 23.6752 29.9613C22.7136 30.5226 21.6215 30.8214 20.5081 30.8278C19.3947 30.8342 18.2992 30.5479 17.3313 29.9978C16.3633 29.4476 15.5569 28.6527 14.9928 27.6928L20.4725 24.5008Z",
    stroke: "#B64627",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4553_1882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9463,
    height: 16.9463,
    fill: "white",
    transform: "translate(12 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptxIcon);
export default __webpack_public_path__ + "static/media/pptx-icon.3f84b5a25348601a48fd0e6ab3b931d4.svg";
export { ForwardRef as ReactComponent };